(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["booking-form"] && !Shopify.designMode) return;
  try {
    (function () {
    const wrap = document.querySelector('[data-booking-toggle]');
    if (!wrap) return;

    const showBtn = wrap.querySelector('[data-booking-show]');
    const form = wrap.querySelector('[data-booking-form]');
    const buttons = wrap.querySelector('[data-booking-buttons]');
    const cancelBtn = wrap.querySelector('[data-booking-cancel]');

    function showForm() {
      form.hidden = false;
      buttons.style.display = 'none';
    }

    function hideForm() {
      form.hidden = true;
      buttons.style.display = 'flex';
    }

    if (
      form.querySelector('.booking-form__success') ||
      form.querySelector('.booking-form__error')
    ) {
      showForm();
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    if (showBtn) {
      showBtn.addEventListener('click', function () {
        showForm();
        const nameInput = form.querySelector('input[name="contact[name]"]');
        if (nameInput) nameInput.focus();
      });
    }

    if (cancelBtn) {
      cancelBtn.addEventListener('click', hideForm);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
